// 分類定数のみここに置く。「その他」はOCR出力を丸ごと捨てる帳票のため FormFieldsSchema・OCR出力スキーマは持たない。
// OCR専用のプロンプト・OCR出力スキーマ（othersSchema）は
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/others.ts）が正本。
export const othersDocumentNameText = 'その他'
